"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniswapWethType = exports.getPair = exports.bigintToHex = exports.toTokens = void 0;
var sdk_1 = require("@uniswap/sdk");
var utils_1 = require("ethers/lib/utils");
var constants_1 = require("../constants");
function toTokens(chainID, tokenInputs) {
    var tokens = [];
    for (var _i = 0, tokenInputs_1 = tokenInputs; _i < tokenInputs_1.length; _i++) {
        var token = tokenInputs_1[_i];
        tokens.push(new sdk_1.Token(chainID, utils_1.getAddress(token.address), token.decimals, token.symbol, token.name));
    }
    return tokens;
}
exports.toTokens = toTokens;
exports.bigintToHex = function (amount) {
    return '0x' + amount.toString(16);
};
function getPair(provider, tokenA, tokenB) {
    if (tokenA.sortsBefore(tokenB)) {
        return sdk_1.Fetcher.fetchPairData(tokenA, tokenB, provider).catch(function () { });
    }
    else {
        return sdk_1.Fetcher.fetchPairData(tokenB, tokenA, provider).catch(function () { });
    }
}
exports.getPair = getPair;
function getUniswapWethType(network) {
    var address = constants_1.getWethAddress(network);
    return new sdk_1.Token(network === 'mainnet' ? 1 : 4, address, 18, 'WETH', 'WETH9');
}
exports.getUniswapWethType = getUniswapWethType;
